import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Spinner from 'react-bootstrap/Spinner';
import { Link } from 'react-router-dom';
import axios from "../../../reducers/authinterceptor";
import AuthHeader from "../../../services/auth.header";

const SuperAdminHome = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const { isSuperAdmin } = useSelector(state => state.auth);

  useEffect(() => {
    if (isSuperAdmin) {
      loadStats();
    }
  }, [isSuperAdmin]);

  const loadStats = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/admin/super/stats",
        { headers: AuthHeader.authHeader() }
      );
      setStats(response.data);
    } catch (error) {
      console.error('Error loading super admin stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  return (
    <Container fluid className="mt-4">
      <h2 className="mb-4">Super Admin Dashboard</h2>
      
      <Row className="mb-4">
        <Col md={3}>
          <Card className="text-center">
            <Card.Body>
              <Card.Title>Total Subsites</Card.Title>
              <h2 className="text-primary">{stats?.totalSubsites || 0}</h2>
              <Link to="/admin/subsites" className="btn btn-sm btn-outline-primary mt-2">
                Manage Subsites
              </Link>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="text-center">
            <Card.Body>
              <Card.Title>Total Users</Card.Title>
              <h2 className="text-success">{stats?.totalUsers || 0}</h2>
              <Link to="/admin/super/users" className="btn btn-sm btn-outline-success mt-2">
                Search Users
              </Link>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="text-center">
            <Card.Body>
              <Card.Title>Open Orders</Card.Title>
              <h2 className="text-warning">{stats?.openOrders || 0}</h2>
              <Link to="/admin/super/orders" className="btn btn-sm btn-outline-warning mt-2">
                View Orders
              </Link>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="text-center">
            <Card.Body>
              <Card.Title>Active Users</Card.Title>
              <h2 className="text-info">{stats?.activeUsers || 0}</h2>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {stats?.oldestOpenOrder && (
        <Row className="mb-4">
          <Col>
            <Card className="border-danger">
              <Card.Body>
                <Card.Title className="text-danger">⚠️ Oldest Open Order Alert</Card.Title>
                <p className="mb-0">
                  The oldest open order is <strong>{stats.oldestOpenOrder.daysOld} days old</strong> 
                  {' '}(Order #{stats.oldestOpenOrder.orderId} from {new Date(stats.oldestOpenOrder.placed).toLocaleDateString()})
                  {' '}in subsite <strong>{stats.oldestOpenOrder.subsiteName}</strong>
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      <Row className="mb-4">
        <Col md={6}>
          <Card>
            <Card.Header>
              <h5>Recent Activity by Subsite</h5>
            </Card.Header>
            <Card.Body>
              {stats?.subsiteActivity && stats.subsiteActivity.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th>Subsite</th>
                        <th className="text-end">Open Orders</th>
                        <th className="text-end">Active Users</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stats.subsiteActivity.map((subsite, idx) => (
                        <tr key={idx}>
                          <td>{subsite.subsiteName}</td>
                          <td className="text-end">{subsite.openOrders}</td>
                          <td className="text-end">{subsite.activeUsers}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-muted">No activity data available</p>
              )}
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card>
            <Card.Header>
              <h5>Quick Actions</h5>
            </Card.Header>
            <Card.Body>
              <div className="d-grid gap-2">
                <Link to="/admin/super/users" className="btn btn-outline-primary">
                  🔍 Search All Users
                </Link>
                <Link to="/admin/super/orders" className="btn btn-outline-primary">
                  📦 Search All Orders
                </Link>
                <Link to="/admin/subsites" className="btn btn-outline-primary">
                  🏢 Manage Subsites
                </Link>
                <Link to="/admin/reports" className="btn btn-outline-primary">
                  📊 View Reports
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SuperAdminHome;

